import { useEffect } from "react";

/**
 * A logged-out visitor clicked an emailed deep link.
 *
 * Park where they were headed and send them to sign in; Login returns them here
 * afterwards. Without this the router falls through to the landing page and the
 * destination is simply lost — the reader arrives at a marketing page with no
 * idea the link ever pointed anywhere.
 *
 * The destination is stashed in the URL rather than localStorage so it dies with
 * the tab: a stale "next" surviving a later, unrelated login would teleport
 * someone into a patient record they didn't ask for.
 */
export default function LinkSignInRedirect() {
  useEffect(function () {
    const dest = (window.location.hash || "").replace(/^#/, "");
    window.location.hash = `#/login?next=${encodeURIComponent(dest)}`;
  }, []);
  return null;
}
